module.exports = __webpack_public_path__ + "img/booking.e1a9c3e6.svg";